import styled from "styled-components";

export const RelatedProductContainer = styled.div`
    padding: 0 30px;
    background: #fff;
    @media screen and (max-width: 612px){
        padding: 30px 7.5px 100px !important;
	}
`;

export const RelatedProductTitle = styled.div`
    padding-bottom: 20px;
    color: #9cc54b;
    font-size: 35px;
    font-weight: 600;

    @media screen and (max-width: 425px){
        font-size: 25px;
        font-weight: 500;
    }
    &.express {
        color: #F01266;
    }
`;

export const SeeMoreButtonContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
 
export const SeeMoreButton = styled.button`
    color: #fff;
    font-weight: 600;
    background-color: #9cc54b;
    border: 1px solid #9cc54b;
    padding: 5px 20px;
    border-radius: 5px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    transform: transform 0.5s linea box-shadow 0.5s ease-in-out;
    &:hover {
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        transform: transform 0.5s linea box-shadow 0.5s ease-in-out;
    }
`